import PropTypes from 'prop-types';

import ButtonClean from '~/components/ButtonClean';

import useBooleanState from '~/hooks/useBooleanState';

import { ReactComponent as MoreIcon } from '~/assets/images/icons/more.svg';

import styles from './ActionButton.module.scss';

function ActionButton({ children }) {
  const [show, toggleShow] = useBooleanState();

  return (
    <ButtonClean
      className={styles.actionButton}
      onClick={toggleShow}
    >
      <div>
        <MoreIcon />
      </div>
      <div className={styles.actionsContainer}>{show && children}</div>
      {show && <ButtonClean onClick={() => toggleShow.setFalse()} />}
    </ButtonClean>
  );
}

ActionButton.propTypes = {
  children: PropTypes.node,
};

export default ActionButton;
